<template>
  <div>
    <h3>
      Puno hvala na interesovanju da postanete personalni/a asistent/kinja ili
      asistent/kinja u kući! Vaša Prijava je uspješno podnijeta. Ukoliko budemo
      imali potrebu za dodatnim pojašnjenjima, kontaktiraćemo Vas. Ukoliko
      imate pitanja, slobodno nas
      <a href="https://imiboke.me/contact-us/" target="_blank">kontaktirajte</a>.
    </h3>
  </div>
</template>

<script></script>
